import { Organization } from '../../../types/organization';
import { ApiAbstract } from '../abstract';

export class ApiOrganization extends ApiAbstract<Organization, any> {}
